/**
 *
 * AddAmbassadorSelect
 *
 */

import React, { Fragment } from "react"
import { Form, Button } from "antd"
import Select from "../Select"
import ModalAmbassadorAssign from "../ModalAmbassadorAssign"

const FormItem = Form.Item

export default class AddAmbassadorSelect extends React.Component {
  state = {
    modalAmbassadorAsign: false,
    collaborator: undefined,
  }

  render() {
    const { props } = this
    return (
      <Fragment>
        <FormItem style={{ marginBottom: 0 }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "260px 90px",
              gridColumnGap: 7,
            }}>
            <Select
              placeholder="Asignar embajador"
              options={Array.isArray(props.data) ? props.data : []}
              labelKey="id_employee"
              label="full_name"
              value={this.state.collaborator}
              allowClear
              style={{ width: 260 }}
              onChange={(event) => this.setState({ collaborator: event })}
            />

            <Button
              className="buttonDisabled"
              style={{ fontSize: 13, paddingTop: 4 }}
              disabled={!this.state.collaborator}
              type="primary"
              onClick={() => this.setState({ modalAmbassadorAsign: true })}>
              Asignar
            </Button>
          </div>
        </FormItem>

        <ModalAmbassadorAssign
        isLoadingLanguage={this.props.isLoadingLanguage}
        languages={this.props.languages}
        getLanguage={this.props.getLanguage}
          selectedDivision={this.props.selectedDivision}
          selectedEmployee={this.state.collaborator}
          open={this.state.modalAmbassadorAsign}
          onCancel={() => this.setState({ modalAmbassadorAsign: false })}
          onFinish={(result) => {
            this.props.updateAmbassadors({
              id_ambassador: result[0].id_ambassador,
              id_employee: this.state.collaborator.id_employee,
              full_name: result[0].employee.full_name,
              first_name: result[0].employee.first_name,
            })
            this.setState({
              modalAmbassadorAsign: false,
              collaborator: undefined,
            })
          }}
        />
      </Fragment>
    )
  }
}
